import { render, staticRenderFns } from "./sysuser_data_scope_edit.vue?vue&type=template&id=bb058ea2&scoped=true"
import script from "./sysuser_data_scope_edit.vue?vue&type=script&lang=js"
export * from "./sysuser_data_scope_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb058ea2",
  null
  
)

export default component.exports